module.exports = __webpack_public_path__ + "static/media/snowytrips.8ffc4415.PNG";